export const BASE = 'INTEGRATION_CONFIGS_LOAD';
export const LOAD_START = `${BASE}_START`;
export const LOAD_SUCCESS = `${BASE}_SUCCESS`;
export const LOAD_FAIL = `${BASE}_FAIL`;

export const LOAD_SINGLE_BASE = 'LOAD_ONE_INTEGRATION_CONFIG';
export const LOAD_SINGLE_START = `${LOAD_SINGLE_BASE}_START`;
export const LOAD_SINGLE_SUCCESS = `${LOAD_SINGLE_BASE}_SUCCESS`;
export const LOAD_SINGLE_FAIL = `${LOAD_SINGLE_BASE}_FAIL`;

export const LOAD_AVAILABLE_XAGENTS_BASE =
  'INTEGRATION_CONFIGS_LOAD_AVAILABLE_XAGENTS';
export const LOAD_AVAILABLE_XAGENTS_START = `${LOAD_AVAILABLE_XAGENTS_BASE}_START`;
export const LOAD_AVAILABLE_XAGENTS_SUCCESS = `${LOAD_AVAILABLE_XAGENTS_BASE}_SUCCESS`;
export const LOAD_AVAILABLE_XAGENTS_FAIL = `${LOAD_AVAILABLE_XAGENTS_BASE}_FAIL`;

const PLAN_EMBEDS = [
  'constants',
  'endpoints',
  'forms',
  'forms.recipients',
  'integrations',
  'integrations.ownerApiKey',
  'permitted',
];

export function load() {
  return {
    type: BASE,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/plans',
      method: 'get',
      params: {
        embed: PLAN_EMBEDS.join(','),
        planType: 'BUILT_IN',
        limit: 1000,
      },
    },
  };
}

export function loadOneConfig(planId, opts) {
  const isPolling = opts && opts.isPolling;
  return {
    type: LOAD_SINGLE_BASE,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${planId}`,
      method: 'get',
      params: {
        embed: PLAN_EMBEDS.join(','),
      },
    },
    payload: {
      isPolling,
    },
  };
}

export function loadAvailableXAgents() {
  return {
    type: LOAD_AVAILABLE_XAGENTS_BASE,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/agents?status=SHOW_ALL&embed=monitors.recipient',
      method: 'get',
    },
  };
}
